export default __webpack_public_path__ + "static/buildingSmart-3a0a9d13bc9f6d0b4995bd46e85d7857.png";